module.exports = __webpack_public_path__ + "img/tiger.c34f4ce4.png";